// extracted by mini-css-extract-plugin
export default {"banner":"_3YDveqVVAjP10bX4TPqpHt","text":"X0zEQ1nNEPWJTpsKMOYYj","cta":"_6gPOmNfDUF5bsTv8v8PKjW"};